// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";

function NotFoundPage(Props) {
  return React.createElement("div", {
              className: CSS$MakerDs.prefix("")
            }, "not found");
}

var make = NotFoundPage;

export {
  make ,
}
/* react Not a pure module */
